import { API_ROUTE_SERVICES } from '@/api/apiRoutes'
import api from '@/lib/api'
import { servicesSlug } from '@/res/consts'
import { IHostingPlan } from '@/types/Hosting'

export const getDnsPlans = async () => {
  try {
    const { data } = await api.get<IHostingPlan[]>(
      `${API_ROUTE_SERVICES}${servicesSlug.dns}/plans`
    )

    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
